export enum InputMode {
  Search = 'search',
  Email = 'email',
  Text = 'text',
  Numeric = 'numeric',
  None = 'none',
  Tel = 'tel',
  Url = 'url',
  Decimal = 'decimal'
}
